import React from 'react'
import ListWrapper from 'redesign/components/organisms/ListWrapper'
import EmptyPage from 'redesign/components/organisms/empty-pages'
import { EMPTY_PAGE_VARIANTS } from 'redesign/components/organisms/empty-pages/constants'
import NewsletterCard from 'redesign/components/organisms/newsletter-card'
import type { NewsletterContentProps } from './types'

const NewsletterContent: React.FC<NewsletterContentProps> = ({
  newsletters,
  loading,
  showLoadMoreElements,
  loadMore,
}) => (
  <ListWrapper
    hasContent={Boolean(newsletters.length)}
    isLoading={loading}
    loadMore={loadMore}
    showLoadMoreButton={showLoadMoreElements}
    noContentBlock={<EmptyPage variant={EMPTY_PAGE_VARIANTS.noNewsletter} />}
  >
    {newsletters?.map((cardContent) => (
      <NewsletterCard key={cardContent.uuid} content={cardContent} />
    ))}
  </ListWrapper>
)

export default NewsletterContent
